<template>
  <div class="layout">
    <div class="nav">
      <div class="nav-logo">
        <img
          src="../../assets/image/home/logo_w.png"
          class="headlefticon"
          @click="go('Home')"
          style="cursor: pointer;"
        />
      </div>
      <div class="nav-status flex-row-between">
        <el-breadcrumb separator="|" class="text-right">
          <el-breadcrumb-item>
            <a @click="go('Home')">首页</a>
          </el-breadcrumb-item>

          <!-- <el-breadcrumb-item>
            <a @click="go('Subject')">培训课程</a>
          </el-breadcrumb-item> -->

          <!-- <el-breadcrumb-item>
            <a @click="go('Simulation')">模拟练习</a>
          </el-breadcrumb-item> -->

          <el-breadcrumb-item>
            <a @click="go('Examination')">参加考试</a>
          </el-breadcrumb-item>

          <el-breadcrumb-item v-if="agent">
            <a @click="toagent">代理列表</a>
          </el-breadcrumb-item>

          <el-breadcrumb-item v-if="signupshow">
            <a
              @click="tosignup"
              style="color:rgb(64, 158, 255)!important;cursor:pointer;"
              >立即报名</a
            >
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="main">
      <el-container>
        <el-aside>
          <el-menu
            :default-active="$route.path"
            class="navbar"
            mode="vertical"
            :router="true"
            :unique-opened="true"
            active-text-color="#fb5227"
          >
            <el-submenu index="1" default-openeds="1">
              <template slot="title">个人资料</template>
              <el-menu-item index="/usercenter/info">我的资料</el-menu-item>
              <el-menu-item index="/usercenter/resetpassword"
                >修改密码</el-menu-item
              >
              <el-menu-item index="/usercenter/resetmobile"
                >修改手机号</el-menu-item
              >
            </el-submenu>

            <!-- <el-submenu index="8">
              <template slot="title">预约时间</template>
              <el-menu-item index="/usercenter/appointment"
                >预约时间</el-menu-item
              >
            </el-submenu> -->
            <el-submenu index="2">
              <template slot="title">我的成绩</template>
              <el-menu-item index="/usercenter/score">评测成绩</el-menu-item>
            </el-submenu>
            <el-submenu index="3">
              <template slot="title">我的证书</template>
              <el-menu-item index="/usercenter/certs">我的证书</el-menu-item>
            </el-submenu>
            <!-- <el-submenu index="4">
              <template slot="title">证书申请</template>
              <el-menu-item index="/usercenter/apply"
                >申请</el-menu-item
              >
            </el-submenu> -->
            <!-- <el-submenu index="5">
              <template slot="title">我的作品</template>
              <el-menu-item index="/usercenter/workslist"
                >个人上传作品列表</el-menu-item
              >
            </el-submenu> -->
            <el-submenu index="6">
              <template slot="title">支付记录</template>
              <el-menu-item index="/usercenter/paylist"
                >我的支付记录</el-menu-item
              >
            </el-submenu>
            <el-menu-item index="7" @click="logout"
              ><span>退出</span></el-menu-item
            >
          </el-menu>
        </el-aside>
        <el-main class="content">
          <router-view></router-view>
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Layout',
  components: {},
  data() {
    return {
      name: '',
      show: 'info',
      signupshow: '',
      agent: '',
    }
  },
  mounted() {},
  created() {
    let _this = this
    _this.agent = _this.Storage.getStorage('agent')
    // _this.$http
    //   .post(process.env.VUE_APP_URL + 'isPay', { good_id: 1 })
    //   .then(data => {
    //     this.token = data.data.token
    //     if (data.data.code == 403) {
    //       _this.$message.error(data.data.msg)
    //       return
    //     }
    //     if (data.data.code == 200) {
    //       _this.signupshow = true
    //     } else {
    //       _this.signupshow = false
    //     }
    //   })
    //   .catch(err => {
    //     _this.$message.error('网络错误，请重试')
    //     console.log(err)
    //   })
  },
  methods: {
    logout() {
      let _this = this
      _this.$http
        .post(process.env.VUE_APP_URL + 'logout')
        .then(function(data) {
          if (data.code == 403 || data.code == 500) {
            _this.$message.error(data.data.msg)
            return
          }
          _this.$store.commit('setUser', {})
          _this.Storage.delStorage('token')
          _this.Storage.delStorage('agent')
          _this.Storage.delStorage('Kstoken')
          window.location.href = '/'
          return
        })
        .catch(function(error) {
          console.log(error)
          _this.$message.error('网络错误,请刷新界面重试')
          return
        })
    },
    toHome() {
      this.$router.push({ path: '/' })
    },
    tosignup() {
      this.$router.push({
        name: 'Traincourse',
        params: {
          signStore: this.signupshow,
        },
      })
    },
    toagent() {
      var Days = 30
      var exp = new Date()
      exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000)
      document.cookie =
        'AgentCode=' +
        escape(this.agent.numbers.trim()) +
        ';expires=' +
        exp.toUTCString()
      window.open('/microlist')
      // this.$router.push({ name: "MicroList" });
      // this.$router.push({
      //   name: 'MicroLogin',
      //   params: {
      //     number:this.agent.numbers
      //   },
      // })
    },
    go(name) {
      this.$router.push({ name: name })
    },
  },
}
</script>
<style lang="less" scoped>
@import '../../common/css/base.css';
@import '../../common/css/common.less';
.nav {
  min-width: 1200px;
  position: fixed;
  width: 100%;
  background: #fb5227;
  overflow-y: auto;
  top: 0;
  z-index: 999;
  a {
    cursor: pointer !important;
  }
  display: flex;
}
.nav-status {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  box-sizing: border-box;
  position: relative;
  a {
    color: #fff !important;
    font-weight: normal !important;
  }
  /deep/.el-breadcrumb {
    font-size: 18px;
    margin-right: 40px;
    .el-breadcrumb__inner {
      color: #fff !important;
    }
    .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
      color: #fff !important;
    }
  }
  /deep/.navbar {
    border-bottom: none !important;
    .el-submenu__title {
      padding: 0 10px !important;
      color: #333 !important;
      font-size: 16px;
      i {
        display: none;
      }
    }
    .el-menu-item {
      font-size: 16px;
      color: #333 !important;
    }
  }
}
.nav-logo {
  background: #fb5227;
  padding: 5px 200px;
  width: 200px;
}

.main {
  width: 60%;
  min-width: 1100px;
  margin: 85px auto 100px;
  .el-aside {
    width: 250px !important;
    position: fixed;
    background: #fff;
    z-index: 999;
  }
}

.content {
  margin-left: 300px;
}
.content::-webkit-scrollbar {
  display: none;
}

.headlefticon {
  height: 45px;
}
</style>
